<template>
  <div class="boss-message-box">
    <img
      src="@/assets/images/avatar-company.svg"
      class="boss-message-box-avatar"
    >
    <div class="boss-layout-block">
      <applicant-message-history-message-detail
        :body="body"
        :date="date"
        :subject="subject"
        :is-read="isRead"
      />
      <applicant-message-history-interview-adjustment
        v-if="interviewAdjustment"
        :candidate-dates="interviewAdjustment.candidateDates"
        :place="interviewAdjustment.place"
        :duration="interviewAdjustment.duration"
        :content-names="interviewAdjustment.contentNames"
        :remarks="interviewAdjustment.remarks"
      />
      <template v-if="files.length">
        <div
          class="pega-file-download-content"
          data-test="file-content"
        >
          添付ファイル
        </div>
        <div
          v-for="file in files"
          :key="file.id"
          class="position-relative"
        >
          <span :data-test="`file-label-${file.id}`">
            {{ file | formatFile }}
          </span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { now, createDate } from '@/lib/dateUtils.js'
import { formatBytes } from '@/lib/formatBytes'
import ApplicantMessageHistoryMessageDetail from '@/components/molecules/ApplicantMessageHistoryMessageDetail.vue'
import ApplicantMessageHistoryInterviewAdjustment from '@/components/molecules/ApplicantMessageHistoryInterviewAdjustment.vue'

export default {
  components: {
    ApplicantMessageHistoryMessageDetail,
    ApplicantMessageHistoryInterviewAdjustment
  },
  filters: {
    formatFile (file) {
      if (now().isAfter(createDate(file.expiredDate), 'days')) {
        return `${file.name} 閲覧期限終了`
      } else if (file.deletedCompanyStaff && file.manualDeletedDate) {
        return `${file.name} ${file.deletedCompanyStaff}によって${createDate(file.manualDeletedDate)?.format('YYYY-MM-DD')}に削除済み`
      } else {
        const sizeLabel = `(${formatBytes(file.size)})`
        return `${file.name}${sizeLabel} 閲覧期限 ${createDate(file.expiredDate)?.format('YYYY-MM-DD')}`
      }
    }
  },
  props: {
    body: {
      type: String,
      default: ''
    },
    date: {
      type: String,
      default: ''
    },
    subject: {
      type: String,
      default: ''
    },
    isRead: {
      type: Boolean,
      default: false
    },
    interviewAdjustment: {
      type: Object,
      default: () => (null)
    },
    files: {
      type: Array,
      default: () => []
    }
  }
}
</script>
